// extracted by mini-css-extract-plugin
module.exports = {"main":"Switch_main__jv9vY","switch":"Switch_switch__KLW4G","is_off":"Switch_is_off__1TrOC"};